import axiosIns from '@axios'
// import { AWS_FILE_OPERATION_TIMEOUT_MS } from '@/api/fileManagement'
// import type { KopItemArtworkPiece } from '@/models/kop/kopItem'
// import type { KopArtworkItemOption } from '@/models/kop/kopArtworkItem'
// import type { SettingsPage } from '@/api/kopArtworkItems'
// import type { CopyKopItemTypesPayload, CopyKopItemTypesResponse } from '@/models/kop/kopItemType'

const $http = axiosIns

// KOP Item Types
export const $copyMultipleKopItemTypes = (payload: object) =>
  $http.post('copy-multiple-kop-item-types/', payload)

export const $getKopItemTypes = async (filters: object) => {
  return await $http.get('kop-item-types/', { params: filters })
}

export const $createKopItemType = async (payload: object) => {
  return await $http.post('kop-item-types/', payload, { headers: { 'Content-Type': 'multipart/form-data' }})
}

export const $updateKopItemType = async (id: number | string, payload: object) => {
  return await $http.patch(`kop-item-types/${id}/`, payload, { headers: { 'Content-Type': 'multipart/form-data' }})
}

export const $deleteKopItemType = async (id: number) => {
  return await $http.delete(`kop-item-types/${id}/`)
}

export const $getKopItemType = async (id: number) => {
  return await $http.get(`kop-item-types/${id}/`)
}

export const $getKopItemTypeOptions = async () => {
  return await $http.options('kop-item-types/')
}

export const $getKopItemTypeCatalogues = async (filters: object) => {
  return await $http.get('kop-item-type-catalogues/', { params: filters })
}

export const $createKopItemTypeCatalogue = async (payload: object) => {
  return await $http.post('kop-item-type-catalogues/', payload)
}

export const $updateKopItemTypeCatalogue = async (id: number | string, payload: object) => {
  return await $http.patch(`kop-item-type-catalogues/${id}/`, payload)
}

export const $deleteKopItemTypeCatalogue = async (id: number | string) => {
  return await $http.delete(`kop-item-type-catalogues/${id}/`)
}

export const $getKopItemTypeCatalogueOptions = async () => {
  return await $http.options('kop-item-type-catalogues/')
}

// KOP Items
export const $getKopItems = async (filters: object, config: object = {}) => {
  return await $http.get('kop-items/', { params: filters, ...config })
}

export const $createKopItem = async (payload: object) => {
  return await $http.post('kop-items/', payload)
}

export const $updateKopItem = async (id: number | string, payload: object) => {
  return await $http.patch(`kop-items/${id}/`, payload)
}

export const $deleteKopItem = async (id: number) => {
  return await $http.delete(`kop-items/${id}/`)
}

export const $getKopItem = async (id: number) => {
  return await $http.get(`kop-items/${id}/`)
}

export const $getKopItemOptions = async () => {
  return await $http.options('kop-items/')
}

// KOP Item status history
export const $getKopItemHistory = async (params: object) => {
  return await $http.get('/kop-item-history/', { params: params })
}

// KOP Scoping Photos
export const $getKopScopingPhotos = async (params: object) => {
  return await $http.get('/kop-scoping-photos/', { params: params })
}

export const $createKopScopingPhoto = async (payload: object) => {
  return await $http.post('/kop-scoping-photos/', payload)
}

export const $deleteKopScopingPhoto = async (id: number | string) => {
  return await $http.delete(`/kop-scoping-photos/${id}/`)
}

// KOP Item Chart
export const $getKopItemsChart = async (filters: object) => {
  return await $http.get('kop-items-chart/', { params: filters })
}

// User KOP Items
export const $getUserKopItems = async (filters: object) => {
  return await $http.get('kop-items-user/', { params: filters })
}

// Global KOP Item Search
export const $kopItemsGlobalOptions = async (filters: object) => {
  return await $http.get('kop-items-global-options/', { params: filters })
}

// Multiple KOP Items update
export const $multipleUpdateKopItemFA = async (payload: object) => {
  return await $http.post('multiple-update-kop-item-fa/', payload)
}

export const $multipleUpdateKopItemAssignee = async (payload: object) => {
  return await $http.post('multiple-update-kop-item-assignee/', payload)
}

export const $multipleUpdateKopItemStatus = async (payload: object) => {
  return await $http.post('multiple-update-kop-item-status/', payload)
}

export const $multipleUpdateKopItemOnHold = async (payload: object) => {
  return await $http.post('multiple-update-kop-item-on-hold/', payload)
}

export const $multipleUpdateKopItemPriority = async (payload: object) => {
  return await $http.post('multiple-update-kop-item-priority/', payload)
}

export const $multipleUpdateKopItemVisibility = async (payload: object) => {
  return await $http.post('multiple-update-kop-item-visibility/', payload)
}

export const $multipleUpdateKopItemExtRefNum = async (payload: object) => {
  return await $http.post('multiple-update-kop-item-ext-ref-num/', payload)
}

// Kop Item Statuses
export const $getKopItemWfPreviousStatuses = async (id: number | string) => {
  return await $http.get(`kop-item-wf-previous-statuses/${id}/`)
}

// Approve/reject Kop Item
export const $approveKopItem = async (id: number | string, payload: object) => {
  return await $http.patch(`approve-kop-item/${id}`, payload)
}

export const $multipleApproveKopItem = async (payload: object) => {
  return await $http.post('multiple-approve-kop-item/', payload)
}

// Export Excel KOP Items
// Export Excel KOP Items from Map View
export const $exportExcelKopItems = async (payload: object) => {
  return await $http.post('/export-excel-kop-items/', payload)
}

// Export Excel KOP Items from Global Search View
export const $exportGlobalKopItems = async (payload: object) => {
  return await $http.post('/export-global-kop-items/', payload)
}
